var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHandRaised = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 1.025 0.782",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style869",
    type: "text/css"
  }, ".st0{fill:#ffd3b6}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path871",
    d: "M220.8 196.584",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1059",
    transform: "matrix(.05125 0 0 .05125 -14.217 -12.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1044",
    d: "M288.372 256.007",
    className: "st0",
    style: {
      strokeWidth: 0.0389037
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1046",
    d: "M294.69 257.645c-.424-.378-1.361-.899-3.287.953-.358.342-.572.467-.844.762v-9.134c0-.591-.467-1.074-1.062-1.074-.596 0-1.078.483-1.078 1.074v5.419c0 .506-.654.549-.767.132v-6.465c0-.592-.466-1.074-1.062-1.074-.595 0-1.077.478-1.077 1.074v6.485c-.082.397-.665.381-.708-.047v-5.664a1.06 1.06 0 0 0-1.062-1.07c-.596 0-1.078.478-1.078 1.07v5.575q-.005.01-.004.039c0 .486-.626.529-.74.136v-3.992a1.06 1.06 0 0 0-1.061-1.07c-.595 0-1.078.479-1.078 1.07v9.392a4.77 4.77 0 0 0 2.739 4.314v1.525c0 .591.482 1.074 1.074 1.074h4.295c.591 0 1.073-.483 1.073-1.074v-1.081a2.52 2.52 0 0 0 1.755-1.031.3.3 0 0 0 .031-.047q.053-.059.128-.21.04-.069.074-.144c.494-1 1.623-3.708 3.646-5.458.416-.417.517-1.082.093-1.46z",
    style: {
      fill: "#ffd469",
      strokeWidth: 0.0389037
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1048",
    d: "M288.726 266.013H285.4l.007-.007h-.871a4.8 4.8 0 0 1-2.027-.451v1.361c.194.102.38.168.54.168h5.373c.156 0 .339-.051.53-.133v-.949z",
    style: {
      fill: "#ffb636",
      strokeWidth: 0.0389037
    }
  })));
};
export { SvgHandRaised as ReactComponent };